import { Badge } from 'cpool-components/general/Badge';
import type {
    SchemaLoanRequestResolver_Find,
    SchemaLoanRequestResolver_GetDuplicateInfoByLead,
    SchemaLoanRequestResolver_GetSummary,
} from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';

import { getSchufaTraits } from '~/utils/leadTraits/getSchufaTraits';

type Props = {
    lead:
        | SchemaLoanRequestResolver_GetSummary[number]
        | (SchemaLoanRequestResolver_Find[number] & {
              antragsteller1: NonNullable<SchemaLoanRequestResolver_Find[number]['antragsteller1']>;
          })
        | SchemaLoanRequestResolver_GetDuplicateInfoByLead[number];
};

const ITEMS_PER_ROW = 3;

export const LeadTraitInfo: React.FC<Props> = ({ lead }) => {
    const { t } = useTranslation();
    const traits = getSchufaTraits(lead ?? null, lead?.schufaSummary ?? null, t);
    const visibleTraits = Object.values(traits).filter((info): info is NonNullable<typeof info> => info !== null);

    const rows = [visibleTraits.slice(0, ITEMS_PER_ROW), visibleTraits.slice(ITEMS_PER_ROW, ITEMS_PER_ROW * 2)];

    return (
        <div className="flex flex-col gap-2 px-4 py-3 text-sm text-midnight min-w-[250px] max-w-[250px] z-100">
            {rows.map((row, rowIndex) =>
                row.length > 0 ? (
                    <div key={rowIndex} className="flex flex-row gap-2 z-100">
                        {row.map((info) => (
                            <Badge
                                key={info.text}
                                iconLeft={info.Icon}
                                iconRight={info.dotText}
                                separatorRight={<span>•</span>}
                                color={info.dot}
                                showTextOnHover={true}
                            >
                                {info.text}
                            </Badge>
                        ))}
                    </div>
                ) : null,
            )}
        </div>
    );
};
